<ng-container *ngIf="viewModel$ | async as vm">
  <app-radio-button-group [selectedIndex]="scaleIndex(vm.scale)" size="small">
    <app-radio-button-item (click)="setScale(EnumScales.MONTH_DAILY)"
      [selected]="vm.scale === EnumScales.MONTH_DAILY" ga-event="ReportsMonth">
      <app-radio-button-label class="is-family-semiBold" [text]="scaleLabel(EnumScales.MONTH_DAILY) | AsyncLang | async"></app-radio-button-label>
    </app-radio-button-item>
    <app-radio-button-item (click)="setScale(EnumScales.YEAR)"
      [selected]="vm.scale === EnumScales.YEAR" ga-event="ReportsYear">
      <app-radio-button-label class="is-family-semiBold" [text]="scaleLabel(EnumScales.YEAR) | AsyncLang | async"></app-radio-button-label>

    </app-radio-button-item>
  </app-radio-button-group>
</ng-container>